/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_aria_label15 = /** @type {(inputs: {}) => string} */ () => {
	return `Search resources`
};

const fr_search_aria_label15 = /** @type {(inputs: {}) => string} */ () => {
	return `Chercher des ressources`
};

const de_search_aria_label15 = /** @type {(inputs: {}) => string} */ () => {
	return `Ressourcen durchsuchen`
};

const es_search_aria_label15 = /** @type {(inputs: {}) => string} */ () => {
	return `Buscar recursos`
};

const it_search_aria_label15 = /** @type {(inputs: {}) => string} */ () => {
	return `Cerca raccolte`
};

const ar_search_aria_label15 = /** @type {(inputs: {}) => string} */ () => {
	return `البحث في المجموعات `
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_aria_label15 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_aria_label15(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_aria_label15", locale)
	if (locale === "en") return en_search_aria_label15(inputs)
	if (locale === "fr") return fr_search_aria_label15(inputs)
	if (locale === "de") return de_search_aria_label15(inputs)
	if (locale === "es") return es_search_aria_label15(inputs)
	if (locale === "it") return it_search_aria_label15(inputs)
	return ar_search_aria_label15(inputs)
};
export { search_aria_label15 as "SEARCH_ARIA_LABEL" }